export default {
  e2eTranslationCheck: {
    id: 'product-page-e2e-translation-check',
    defaultMessage: 'Product page e2e translations check default message',
  },
}
